<ngx-spinner bdColor="rgba(0, 0, 0, 0.5)" [fullScreen]="true">
  <div class="custom-spinner">
    <img
      src="/assets/icons/spinner-otic-2018.png"
      alt="Logo Empresa"
      class="spinner-logo"
    />
  </div>
</ngx-spinner> 
  

<div class="custom-container">
  <app-header></app-header>
  <app-sidebar></app-sidebar>
  <div class="container-fluid pt-md-3" style="min-height: calc(100vh - 57px) !important; background-color: #F8F9FB; padding-left: 120px; padding-right: 60px;">
    <div style="min-height: calc(100vh - 121px) !important; background-color: #F8F9FB;">
        <router-outlet></router-outlet>
    </div>
  </div>
</div> 